import MailACheckPage from './steps/MailCheck/MailACheckPage';
export const listSteps = [
  {
    id: '1',
    stepValues: 1,
    component: <MailACheckPage />,
    label: 'hello world',
    showSecureLink: false,
    showWizard: false,
    summary: false,
  },
];
